import React from "react";
import { Formik } from "formik";
import { CustomFileUpload } from "../../../common/FormInputs";
import useLoader from "../../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import { navigate } from "@reach/router";
import {
  Container,
  StyledForm,
  StyledFormElementsWrapper,
  FormLabel,
  ButtonGroup,
  BackButton,
  SubmitButton,
  MainContainer,
} from "./styles";
import { lexitasStyleValidationSchema } from "../../../../helpers/validationSchema";
import { getFileName } from "../../../../helpers/functions";

const LexitasStyleGuide = () => {
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();

  const onFormSubmit = async (values, { resetForm }) => {
    try {
      setLoader({ state: true, message: "Please wait..." });
      let formData = new FormData();
      formData.append("file", values.excelFile);
      const response = await fetch(
        `https://staging-api.justact.co.in/lexitas-style-guide`,
        {
          method: "POST",
          body: formData,
        },
      );
      if (response.ok) {
        const data = await response.json();
        enqueueSnackbar("File created successfully", {
          variant: "success",
        });
        const a = document.createElement("a");
        a.href = data?.processed_file;
        a.download = `${getFileName(data?.processed_file)}.docx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        resetForm();
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoader({ state: false });
    }
  };

  return (
    <React.Fragment>
      <MainContainer>
        <Container>
          <Formik
            initialValues={{
              excelFile: "",
            }}
            validationSchema={lexitasStyleValidationSchema}
            enableReinitialize
            onSubmit={onFormSubmit}
            validateOnBlur
            validateOnChange
          >
            {({
              values,
              handleChange,
              errors,
              touched,
              handleBlur,
              handleSubmit,
              setFieldValue,
              setFieldError,
              resetForm,
            }) => (
              <StyledForm>
                <StyledFormElementsWrapper
                  style={{ marginBottom: 8, marginTop: 15 }}
                >
                  {[
                    {
                      name: "excelFile",
                      label: "Upload Docx",
                      type: "upload",
                      required: true,
                      fileName: "excel",
                      accept: ".docx",
                      types: [
                        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                      ],
                    },
                  ].map((upload, index) => (
                    <div style={{ marginTop: 10 }}>
                      <FormLabel
                        style={{
                          fontFamily: "openSans-SemiBold, sans-serif",
                          fontSize: 12,
                          color: "#949ab0",
                        }}
                      >
                        {upload.label} <span className="required-star"> *</span>
                      </FormLabel>
                      <CustomFileUpload
                        error={touched[upload.name] && errors[upload.name]}
                        setFile={(file) => setFieldValue("excelFile", file)}
                        style={{
                          width: "100%",
                        }}
                        accept={upload.accept}
                        file={{
                          name: values.excelFile.name || "",
                        }}
                      />
                    </div>
                  ))}
                </StyledFormElementsWrapper>
                <ButtonGroup>
                  <BackButton
                    onClick={() =>
                      navigate("/transcriber/cases?caseType=mediation")
                    }
                  >
                    Back
                  </BackButton>
                  <SubmitButton onClick={handleSubmit}>Submit</SubmitButton>
                </ButtonGroup>
              </StyledForm>
            )}
          </Formik>
        </Container>
      </MainContainer>
    </React.Fragment>
  );
};

export default LexitasStyleGuide;
